/**
 * Formats a naive `YYYY-MM-DD` day string as `M/D`.
 *
 * Parses the parts by hand rather than via `new Date(...)`, which would interpret the string as
 * UTC midnight and render the previous day in negative-offset timezones.
 */
export const formatDayDate = (dateValue: string) => {
  const [year, month, day] = dateValue.split('-').map(Number);
  if ([year, month, day].some((part) => !part)) return '';
  return `${month}/${day}`;
};

export default formatDayDate;
